export const requiredRule = (msg) => {
  return {
    required: true,
    message: msg,
  };
};